/* ============================================================
   KKUMI — Sleeve Guide · Sizes ("Find your size")
   Sleeve rows + card chips are server-rendered from blocks and read
   back via data-*. Selecting either redraws the to-scale plot.
   Fit maths: window.KKSleeveFit (kkumi-sleeve-fit.js).
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';
    var Fit = window.KKSleeveFit;
    var rows = [].slice.call(root.querySelectorAll('[data-fys-row]'));
    var chips = [].slice.call(root.querySelectorAll('[data-fys-card]'));
    if (!Fit || !rows.length || !chips.length) return;

    var L = root.dataset, O = Fit.optsFrom(L);
    var pool = rows.map(function (r) {
      return { name: r.dataset.name, layer: r.dataset.layer, w: +r.dataset.w, h: +r.dataset.h };
    });
    var $ = function (s) { return root.querySelector(s); };
    var sel = $('[data-fys-sel]'), rect = $('[data-fys-cardrect]'), lbl = $('[data-fys-cardlbl]');
    var live = [].slice.call(root.querySelectorAll('[data-fys-live]')), empty = $('[data-fys-empty]');
    var STATES = ['perfect', 'double', 'loose', 'big', 'small'];
    var s = 0, c = 0;

    function draw() {
      var k = chips[c];
      var card = { w: +k.dataset.w, h: +k.dataset.h };
      var results = pool.map(function (p) { return Fit.evaluate(p, card, O, pool); });

      // "Too big" / "too small" sleeves are disabled; keep the selection on one that works.
      var any = results.some(function (x) { return Fit.works(x.state); });
      if (any && !Fit.works(results[s].state)) {
        for (var n = 0; n < results.length; n++) { if (Fit.works(results[n].state)) { s = n; break; } }
      }
      var r = rows[s], sl = pool[s], f = results[s];

      // No sleeve suits this card at all: swap the plot for the request state.
      live.forEach(function (n) { n.hidden = !any; });
      empty.hidden = any;
      if (!any) Fit.fillEmpty(root, { name: k.dataset.name, w: card.w, h: card.h }, $('[data-fys-empty-cta]'), k.dataset.emptyBody);

      rows.forEach(function (x, i) {
        var st = results[i].state;
        x.disabled = !Fit.works(st);
        x.setAttribute('aria-disabled', String(!Fit.works(st)));
        x.setAttribute('aria-pressed', String(i === s && any));
        STATES.forEach(function (n) { x.classList.remove('is-' + n); });
        x.classList.add('is-' + st);
        x.querySelector('[data-fys-row-dim]').textContent = Fit.fmt(L.fmtSize, pool[i].w, pool[i].h);
        x.querySelector('[data-fys-row-v]').textContent = Fit.label(L, st);
      });
      chips.forEach(function (x, i) { x.setAttribute('aria-pressed', String(i === c)); });

      $('[data-fys-nm]').textContent = r.dataset.name;
      var v = $('[data-fys-verdict]');
      v.textContent = Fit.label(L, f.state);
      v.className = 'kk-sv__verdict kk-sv__verdict--' + f.state;
      $('[data-fys-role]').textContent = r.dataset.role;
      $('[data-fys-note]').textContent = Fit.noteFor(L, f, O);
      $('[data-fys-dim]').textContent = Fit.fmt(L.fmtSize, sl.w, sl.h);
      var fill = function (tpl, w, h) { return tpl.replace('{w}', w).replace('{h}', h); };
      var sf = Fit.shortfall(f, O);
      $('[data-fys-room]').textContent = f.state === 'small' ? fill(L.over, sf.w, sf.h) : fill(L.spare, f.sw, f.sh);
      $('[data-fys-w]').textContent = (L.fmtLine || '{n}mm').replace('{n}', sl.w);
      $('[data-fys-h]').textContent = (L.fmtLine || '{n}mm').replace('{n}', sl.h);

      sel.style.setProperty('--w', sl.w);
      sel.style.setProperty('--h', sl.h);
      rect.style.setProperty('--w', card.w);
      rect.style.setProperty('--h', card.h);
      rect.classList.toggle('is-over', f.sw < 0 || f.sh < 0);

      // Card label: name split onto lines, then the size.
      lbl.textContent = '';
      k.dataset.name.split(' ').forEach(function (word) {
        var line = document.createElement('span');
        line.textContent = word;
        lbl.appendChild(line);
      });
      var dims = document.createElement('span');
      dims.textContent = Fit.fmt(L.fmtSize, card.w, card.h);
      lbl.appendChild(dims);
    }

    rows.forEach(function (x, i) { x.addEventListener('click', function () { s = i; draw(); }); });
    chips.forEach(function (x, i) { x.addEventListener('click', function () { c = i; draw(); }); });
    draw();
  }

  function boot() { document.querySelectorAll('[data-kk-fys]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
